export const rootNode = document.getElementById('store-comparison-root');

const parseJSON = (value, fallback) => {
  if (!value) return fallback;
  try {
    const parsed = JSON.parse(value);
    // nil ivars serialize as the "null" literal — treat them as absent
    return parsed == null ? fallback : parsed;
  } catch (_) {
    return fallback;
  }
};

export const initParams = (() => {
  const dataset = rootNode ? rootNode.dataset : {};

  return {
    asOfDateLabel: dataset.asOfDateLabel || '',
    itunesConnect: parseJSON(dataset.itunesConnect, {}),
    googlePlay: parseJSON(dataset.googlePlay, {}),
  };
})();
